export const applicationFlags = {
  isProduction: process.env.REACT_APP_DEPLOYMENT_ENV === 'production',
};
